import 'bluebird'
import 'babel-polyfill'
import 'core-js/modules/es7.promise.finally'

import { isAuthTokenValid } from 'Utils/validations'

class CredentialsError extends Error {}

const defaultHeaders = {
  'Content-Type': 'application/json',
}

export const cleanupTokens = (storage) =>
  Promise.all([storage.removeItem('authToken'), storage.removeItem('authTokenExpirationDate')])

export default ({ fetch = global.fetch, storage = global.localStorage }) => {
  if (!storage) {
    throw new CredentialsError('storage is required')
  }
  if (!fetch) {
    throw new CredentialsError('fetch is required')
  }

  const updateTokens = async (response) => {
    const token = response.headers.get('X-ConsumerApi-Token') || 'token'
    const expirationDate =
      response.headers.get('X-ConsumerApi-Token-Expiration-Date') ||
      new Date('20 september 2018').toISOString()
    return Promise.all([
      storage.setItem('authToken', token),
      storage.setItem('authTokenExpirationDate', expirationDate),
    ])
  }

  const getValidAuthToken = async () => {
    const authToken = await storage.getItem('authToken')
    const authTokenExpirationDate = await storage.getItem('authTokenExpirationDate')

    if (!isAuthTokenValid(authTokenExpirationDate)) {
      return {
        errorneousResponse: {
          ok: false,
          json: new Promise((res) => res()),
        },
      }
    }
    return { authToken }
  }

  const encodeCredentialsToBae64 = ({ email, password }) => btoa(`${email}:${password}`)

  const addAuthenticationHeaders = ({ options, body, authToken }) => {
    const authHeader = authToken
      ? `Basic ${btoa(`:${authToken}`)}`
      : `Basic ${encodeCredentialsToBae64(body)}`
    return {
      ...options,
      body: body ? JSON.stringify(body) : undefined,
      headers: { ...defaultHeaders, Authorization: authHeader },
    }
  }

  return async (input, { login, logout, ...options } = {}, body) => {
    if (login) {
      await cleanupTokens(storage)
      const loginOptions = addAuthenticationHeaders({ options, body })
      const loginRequest = new Request(input, loginOptions)
      const response = await fetch(loginRequest)
      // TODO: Currently we do this equate register user api response with 409 for already registerd user logged in with social logins.
      if (response.ok || response.status === 409) {
        await updateTokens(response)
      }
      return response
    }

    const { authToken, errorneousResponse } = await getValidAuthToken()

    const authOptions = addAuthenticationHeaders({ options, body, authToken })
    const authRequest = new Request(input, authOptions)

    if (logout) {
      await cleanupTokens(storage)
      return fetch(authRequest)
    }

    if (errorneousResponse) {
      return errorneousResponse
    }

    const response = await fetch(authRequest)

    return response
  }
}
